import type { RouteRecordRaw } from 'vue-router';

export const apsRoutes: RouteRecordRaw[] = [
  {
    path: 'aps/scenarios',
    name: 'aps-scenarios',
    component: () => import('../pages/aps/ApsScenariosPage.vue'),
    meta: { requiresModule: 'aps' },
  },
];
